import { Component, Input, Signal, inject, signal, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable, Subscription } from 'rxjs';
import EmployeeService from '../../services/employee.service';

export interface FormField {
  name: string;
  label: string;
  helper?: string;
}

@Component({
  selector: 'app-employee-select-field',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule],
  templateUrl: './employee-select-field.component.html',
})
export class EmployeeSelectFieldComponent implements OnInit, OnDestroy {
  private employeeService = inject(EmployeeService);

  @Input({ required: true }) parentForm!: FormGroup;
  @Input({ required: true }) field!: FormField;
  @Input({ required: true }) loadedData!: Signal<any>;
  @Input() allowCreation: boolean = false;

  employees$: Observable<any[]> = this.employeeService.all();
  isCreating = signal<boolean>(false);

  // Formulaire local pour la saisie manuelle
  newEmployeeForm = new FormGroup({
    lastName: new FormControl('', Validators.required),
    firstName: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  private formSub?: Subscription;

  ngOnInit(): void {
    // Dès que l'un des champs texte change, on met à jour le contrôle principal (ex: employee)
    this.formSub = this.newEmployeeForm.valueChanges.subscribe((value) => {
      if (this.isCreating()) {
        const control = this.parentForm.get(this.field.name);
        control?.setValue(value);

        // On aligne la validité du champ parent sur celle du sous-formulaire
        if (this.newEmployeeForm.invalid) {
          control?.setErrors({ invalidNewEmployee: true });
        } else {
          control?.setErrors(null);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.formSub?.unsubscribe();
  }

  compareValueSelect(item1: any, item2: any): boolean {
    return item1 && item2 ? item1.id === item2.id : item1 === item2;
  }

  enableCreationMode(): void {
    if (!this.allowCreation) return;

    this.newEmployeeForm.reset();
    this.isCreating.set(true);

    const control = this.parentForm.get(this.field.name);
    control?.setValue({ lastName: '', firstName: '', email: '' });
    control?.setErrors({ invalidNewEmployee: true });
  }

  cancelCreationMode(): void {
    this.isCreating.set(false);

    const control = this.parentForm.get(this.field.name);
    control?.setValue(null);
    control?.setErrors(null);
  }
}
